import { render } from "./Navbar.vue?vue&type=template&id=b66f5a16&scoped=true&ts=true"
import script from "./Navbar.vue?vue&type=script&lang=ts"
export * from "./Navbar.vue?vue&type=script&lang=ts"

import "./Navbar.vue?vue&type=style&index=0&id=b66f5a16&lang=scss&scoped=true"

import exportComponent from "C:\\bonch\\okimi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b66f5a16"]])

export default __exports__